import type { Locale } from "@/entities/language";

import dayjs, { extend, locale } from "dayjs";
import calendar from "dayjs/plugin/calendar";
import duration from "dayjs/plugin/duration";
import isBetweenPlugin from "dayjs/plugin/isBetween";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";

import "dayjs/locale/en";
import "dayjs/locale/fr";

import { getAppLocale } from "@/services/language";

import { DAYSJS_CALENDAR_CONFIG } from "./dayjs.constant";

export const initDayJs = () => {
  // Load plugins
  extend(calendar);
  extend(relativeTime);
  extend(LocalizedFormat);
  extend(duration);
  extend(isBetweenPlugin);
  extend(updateLocale);

  // Set default dayjs locale
  setDayJsLocale(getAppLocale());
};

export const setDayJsLocale = (loc: Locale) => {
  // Define dayjs locale
  locale(loc);

  // Update dayjs special configs related to locale
  dayjs.updateLocale(loc, {
    calendar: DAYSJS_CALENDAR_CONFIG[loc] ?? {},
  });
};
